<template>
  <div class="coupon" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="order-tab">
      <span @click="toggle(1)" :class="{curt:1==active}">优惠劵</span>
      <span @click="toggle(2)" :class="{curt:2==active}">返现金额</span>
    </div>
    <div style="height:60px"></div>
    <ul>
      <li v-for="(item,i) in coupon">
        <div class="cate" :style="usePrice - item.use <0 ? 'background:#ccc' : ''">{{item.cate_id > 0 ? '商家代金劵' : '现金余额使用'}}  {{usePrice - item.use <0 ? '-不可用' : ''}}</div>

        <div class="con">
          <h2>{{item.title}}</h2>
          <p>有效期至 {{item.endtime == 0 ? '永久有效' : item.endtime}}</p>
        </div>
        <div class="price">
          <h3><font>￥</font>{{item.endtime == 0 ? (item.use > 10 ? 10 : item.use) : item.price}}</h3>
          <p>{{item.endtime == 0 ? '现金余额'+item.use+'元' : '满'+item.use+'可用'}}</p>
        </div>
        <div class="choose" v-if="usePrice - item.use >= 0">
          <div class="rr">
            <input :id="'item'+i" type="radio" :alt="item.id" @click="priceInput" name="item" :value="item.price">
            <label :for="'item'+i"></label>
          </div>
        </div>
      </li>

    </ul>


    <div class="none" v-if="coupon.length <= 0">
      <img src="~assets/images/none.png" />
      <p>空空如也~</p>
    </div>


    <div style="height:90px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>
          <i>￥</i><b>{{price}}</b>
        </span>
        <span>共选择{{total}}张优惠劵</span>
      </div>
      <div class="pay">
        <span v-if="total < 0" style="background:#ccc">请选择劵</span>
        <span v-if="total >= 0" @click="isOk">确认使用</span>        
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        coupon:[],
        price:0.00,
        total:0,
        usePrice:0,
        active:1,
        coupon_id:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.usePrice = this.$route.query.use;
    },
    mounted() {
      this.beforeMount();
      this.getDetail(1)
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toggle:function(inx){
        this.active = inx;
        this.getDetail(inx)
        this.price = 0;
        this.total = 0;
        this.coupon_id= 0;
        $('.choose input').prop('checked',false);
      },
      priceInput:function(e){
        this.price = e.target.value;
        this.total = 1;
        this.coupon_id= e.target.alt;
      },
      isOk:function(){
        var price = this.price;
        var coupon_id = this.coupon_id;
        localStorage.setItem('coupon', coupon_id+'-'+price+'-'+this.active);
        this.$router.go(-1)
      },
      getDetail:function(type){
        var that = this;
        var id = this.$route.query.id;
        var total = this.$route.query.use;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/getCoupon',
          params:{
            id:id,
            user_id:that.userData.id,
            type:type
          }
        }).then(function(response){
          var res = response.data.data;
          that.coupon = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .coupon{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }
  .coupon .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:0;
    background:#fff;
    z-index:99
  }
  .coupon .order-tab span{
    display:inline-block;
    width:25%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    font-weight:bold;
    position:relative;
  }
  .coupon .order-tab span.curt{
    color:#406DE1;
  }
  .coupon .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:30px;
    height:1px;
    background:#406DE1;
    bottom:0;
    left:50%;
    transform: translateX(-50%);
  }
  .coupon ul{
    width:92%;
    display:block;
    margin:0 auto;
  }
  .coupon ul li{
    width:100%;
    display:block;
    background:#fff;
    border-radius:10px;
    position: relative;
    margin-bottom:10px
  }
  .coupon ul li .cate{
    position: absolute;
    top:0;
    left:0;
    background:rgba(255,30,0,0.7);
    color:#fff;
    border-radius:10px 0 10px 0;
    font-size:14px;
    padding:6px;
  }

  .coupon ul li .con{
    width:92%;
    margin:0 auto;
    padding:40px 0 20px 0;
  }
  .coupon ul li .con h2{
    font-size:20px;
    font-weight:normal;
    width:60%;
  }
  .coupon ul li .con p{
    font-size:15px;
    color:#666;
    padding-top:5px
  }
  .coupon ul li .price{
    position: absolute;
    top:40px;
    right:20%;
  }
  .coupon ul li .price h3{
    font-size:26px;
    color:rgb(255,30,0);
    text-align:center;
  }
  .coupon ul li .price h3 font{
    font-size:15px;
    font-weight:normal
  }
  .coupon ul li .price p{
    color:rgb(255,30,0);
    font-size:15px;
    text-align:center;
    padding-top:2px
  }
  .coupon ul li .choose{
    position: absolute;
    top:45px;
    right:8%;
  }
  .coupon ul li .choose .rr {
    position: relative;
    line-height: 30px;
  }

  .coupon ul li .choose .rr input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }

  .coupon ul li .choose .rr label {
    position: absolute;
    left: 5px;
    top: 8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #999;
  }

  .coupon ul li .choose .rr input:checked+label {
    background:rgb(255,209,97);
    border: 1px solid rgb(255,209,97);
  }

  .coupon ul li .choose .rr input:checked+label::after {
    position: absolute;
    content: "";
    width: 5px;
    height: 10px;
    top: 3px;
    left: 6px;
    border: 2px solid #000;
    border-top: none;
    border-left: none;
    transform: rotate(45deg)
  }

  .coupon .footer1{
    height: 55px;
    background: #000;
    width: 94%;
    border-radius: 55px;
    position: fixed;
    bottom: 20px;
    left: 3%;
    z-index: 1
  }
  .coupon .footer1 .foot-title{
    float: left;
    margin-left: 6%;
    margin-top:8px
  }
  .coupon .footer1 .foot-title span{
    font-size: 14px;
    color: #666;
    margin-right:15px;
    display:block;
  }
  .coupon .footer1 .foot-title span b{
    color: #fff;
    font-size:20px;
    font-weight:600;
  }

  .coupon .footer1 .foot-title span i{
    color: #fff;
    font-size:14px;
    font-style:normal
  }
  
  
  .coupon .footer1 .pay{
    float: right;
    color: #000;
    width:35%
  }
  .coupon .footer1 .pay span{
    float:left;
    height:55px;
    line-height:55px;
    font-size: 16px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background:rgb(255,209,97);
    border-radius:0 40px 40px 0;
  }


  .coupon .none{
    text-align:center;
    padding-top:120px;
  }
  .coupon .none img{
    display:block;
    margin:0px auto;
    width:100px;
  }
  .coupon .none p{
    color:#999;
    font-size:15px;
    padding-top:5px;
    letter-spacing:2px;
  }

</style>